import { createClient } from "@/infrastructures/supabase/client";

export default async function uploadFile(
  file: File,
  filePath: string,
  bucket: string
) {
  const supabase = createClient();
  const stoargeRef = supabase.storage.from(bucket);
  const { error } = await supabase.storage.from(bucket).upload(filePath, file);
  if (error) return { error: error.message };
  const fileURL = stoargeRef.getPublicUrl(filePath).data.publicUrl;
  return { fileURL };
}
